<template>
  <div v-if="event.rsvpMeta">
    <div v-if="event.rsvpMeta.going_friends?.length" class="flex-shrink-1 mx-1">
      <user-avatar-list :users="event.rsvpMeta.going_friends.slice(0, displayedFriendsCount)" :reverse="false" :size="20">
        <users-count-circle
          v-if="event.rsvpMeta.going_users_count > displayedFriendsCount"
          :count="event.rsvpMeta.going_users_count - displayedFriendsCount"
          tiny
          :max-count="99"
          class="ml-n1"
        />
      </user-avatar-list>
    </div>
    <users-count-circle v-else-if="event.rsvpMeta.going_users_count > 0" :count="event.rsvpMeta.going_users_count" tiny :max-count="99" />
  </div>
</template>

<script>
import UserAvatarList from "@/components/users/UserAvatarList.vue"
import UsersCountCircle from "@/components/users/UsersCountCircle.vue"

export default {
  components: {
    UserAvatarList,
    UsersCountCircle
  },
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      displayedFriendsCount: 4
    }
  }
}
</script>
